import { render, staticRenderFns } from "./BloqueioPessoas.vue?vue&type=template&id=6603ed12&"
import script from "./BloqueioPessoas.vue?vue&type=script&lang=js&"
export * from "./BloqueioPessoas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports